import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http'
import { Constant } from '../../environments/constants';
import { Utils } from '../../utils/utils';
import { DataService } from './context/data.service';
//import { UIStateService } from './context/uistate.service';
import { ReferenceService } from '../services/reference/reference.service';
import { AppMonitoringService } from '../services/util/app-monitoring.service';
import * as fromModel from '../services/models/';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GoalAnalysisService {
  goalAnalysisDataObservable: Observable<any>;
  constructor(private http: HttpClient, 
             private referenceService: ReferenceService,
  //           private uiStateService: UIStateService,
             private appMonitoringService: AppMonitoringService) { }

  // getGoalAnalysisAPI_old(plan: fromModel.Plan) {    
  //   return this.http.post<any>(Constant.uri.goalanalysis, plan, Utils.getHttpOptions());
  // } 

  // getGoalAnalysisAPI(plan: fromModel.Plan): Observable<any> {    
  //   if (this.goalAnalysisDataObservable) {
  //     return this.goalAnalysisDataObservable;
  //   } else {
  //     this.goalAnalysisDataObservable = this.http.post<any>(Constant.uri.goalanalysis, plan, Utils.getHttpOptions()).pipe(share());
  //     return this.goalAnalysisDataObservable;
  //   }
  // }

  // getGoalAnalysisAPI(goalAnalysisInput: any): Observable<any> {    
  //   if (this.goalAnalysisDataObservable) {
  //     return this.goalAnalysisDataObservable;
  //   } else {
  //     this.goalAnalysisDataObservable = this.http.post<any>(Constant.uri.goalanalysis, goalAnalysisInput, Utils.getHttpOptions()).pipe(share());
  //     return this.goalAnalysisDataObservable;
  //   }
  // }

  getGoalAnalysisAPI(goalAnalysisInput: any): Observable<any> {    
    if(Constant.config.isLocalMode){
      return this.http.get('./assets/mock/plan-analytics.json');  
    } else {
      return this.http.post<any>(Constant.uri.goalanalysis, goalAnalysisInput, Utils.getHttpOptions());      
    }
  }

  getPlanAnalysis(plan: fromModel.Plan, dataService: DataService, requestParam?: fromModel.GoalAnalysisRequestParam) {
    if(!dataService.appData.PlanAnalysis || dataService.appData.PlanAnalysis['Error']) {
     
      let goalAnalysisInput = {
        "plan": plan
      };

      this.getGoalAnalysisAPI(goalAnalysisInput).subscribe(result=>{
        dataService.dispatchAction(fromModel.DATA_ACTION.PLANANALYSIS,"GoalAnalysisService-getPlanAnalysis - Plan Level", result);
        this.goalAnalysisDataObservable = null;
      }, err=>{
        dataService.dispatchAction(fromModel.DATA_ACTION.PLANANALYSIS,"GoalAnalysisService-getPlanAnalysis - Plan Level", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
        //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG,"GoalAnalysisService-getGoalAnalysis", true);
        console.log("Error getting GoalAnalysis results - Plan Level: Plan - " + JSON.stringify(err));      
        this.appMonitoringService.traceMsg("Error getting GoalAnalysis results - Plan Level: Plan - ", JSON.stringify(err) , 'Error');
      });
      
    }
  }

  getGoalAnalysis(plan: fromModel.Plan, dataService: DataService, action: fromModel.DATA_ACTION, requestParam?: fromModel.GoalAnalysisRequestParam) {
    //if(!dataService.appData.PlanAnalysis || dataService.appData.PlanAnalysis['Error']) {
      //this.createPlanDefaults(plan);
      //this.updatePlanObject(plan, dataService);
      let goalAnalysisInput;

      if(requestParam){
        goalAnalysisInput = {
          "requestParam": requestParam,
          "plan": plan
        };

        this.getGoalAnalysisAPI(goalAnalysisInput).subscribe(result=>{
          dataService.dispatchAction(action,"GoalAnalysisService-getGoalAnalysis", result);
          this.goalAnalysisDataObservable = null;
        }, err=>{
          dataService.dispatchAction(action,"GoalAnalysisService-getGoalAnalysis", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
          //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG,"GoalAnalysisService-getGoalAnalysis", true);
          console.log("Error getting GoalAnalysis results: Plan - " + JSON.stringify(err));      
          this.appMonitoringService.traceMsg("Error getting GoalAnalysis results: Plan - ", JSON.stringify(err) , 'Error');
        });

      } 
    //}
  }




      // "requestParam": {
        //     "cashFlowProjType": "FULL",
        //     "goalSmryReq": false,  //only for cashflow projection 
        //     "isPlanAnalytics": true, // for goal - make it false
        //     //"goalId": [], //populate if isPlanAnalytics - false
        //     //"isGoalAnalytics"
            

        // },
  

  createPlanDefaults(plan: fromModel.Plan){
    //let settings: fromModel.CodeValue[];
    // let goals: fromModel.Goal[];
    // let incomes: fromModel.Income[];
    // let expenses: fromModel.Expense[];
    // let targetAlloc: fromModel.Model;

    //plan.planId = "PL1";
    // settings = [
    //   {
    //     "code": "INC_TX_RT",
    //     "value": "23.0"
    //   },
    //   {
    //     "code": "INF_RT",
    //     "value": "2.6"
    //   },
    //   {
    //     "code": "DISCOUNT_RT",
    //     "value": "1.1"
    //   }
    // ];

    // goals = [{ 
    //   "goalId": "",
    //   "goalType": fromModel.GOALTYPE.LIV,
    //   "goalDesc": "Test Goal",
    //   "priority": 1      
    // }
    // ];

    // incomes = [{
    //   "incId": "I1",
    //   "incSource": fromModel.INCOMESOURCE.Ordinary,
    //   "incType": fromModel.INCOMETYPE.EI,
    //   "incDesc": "Test Income",
    //   "owner": plan.planClients[0].clientid,
    //   "growthType": fromModel.GROWTHTYPE.INF,
    //   "growthRate": 0.0,
    //   "amtPeriod": [
    //     {
    //       "startType": fromModel.AMOUNTPERIODTYPE.Age,
    //       "startYr": 0,
    //       "startAge": 60,
    //       "amount": 50000.0,
    //       "endType": fromModel.AMOUNTPERIODTYPE.AtEnd,
    //       "endYr": 0,
    //       "endAge": 0
    //     }
    //   ]
    // }
    // ];

    // expenses = [{
    //   "expId": "E2",
    //   "expType":fromModel.EXPENSETYPE.HSG, //ED, OT
    //   "expDesc": "Housing",
    //   "owner": plan.planClients[0].clientid,
    //   "growthType": fromModel.GROWTHTYPE.MNF,
    //   "growthRate": 3.0,
    //   "amtPeriod": [
    //     {
    //       "startType": fromModel.AMOUNTPERIODTYPE.Year, //Year, AtRet, Age
    //       "startYr": 2025,
    //       "startAge": 0,
    //       "amount": 50000.0,
    //       "endType": fromModel.AMOUNTPERIODTYPE.AtEnd, //Year, AtRet, Age, AtEnd
    //       "endYr": 0,
    //       "endAge": 0
    //     }
    //   ]
    //  }
    // ];

    // targetAlloc = {
    //     "modelType": fromModel.MODELTYPE.CURRENT, // NULL, MANAGED, CUSTOM, FIRM, CURRENT 
    //     "modelId": null,
    //     "allocations": null
    // };
    // plan.settings = settings;
    // plan.goals = goals;
    // plan.incomes = incomes;
    // plan.expenses = expenses;
    // plan.targetAlloc = targetAlloc;
  }


  // updatePlanObject(plan: fromModel.Plan, dataService){
  //   setTimeout(() => {
  //     if(plan && plan.id.trim()===""){
  //       this.prepareSettings(plan);
  //       this.prepareIncomes(plan, dataService.getClientByRole(fromModel.CLIENTROLE.Primary));
  //     }  
  //   }, 1000);
    
  // }

  // prepareSettings(plan: fromModel.Plan){
  //   let settings: fromModel.CodeValue[] = [];
  //   this.referenceService.getSettingsRefrenceData().subscribe(settingsRef =>{
  //       settings = <fromModel.CodeValue[]>settingsRef;     
  //       plan.settings = settings;            
  //   });          
  // }

  // prepareIncomes(plan: fromModel.Plan, client: fromModel.PlanClient){
  //   let incomes: fromModel.Income[] = [];
  //   incomes.push(this.prepareIncome(fromModel.INCOMETYPE.EI, client));
  //   // incomes.push(this.prepareIncome(fromModel.INCOMETYPE.IN));
  //   // incomes.push(this.prepareIncome(fromModel.INCOMETYPE.SS));
  //   // incomes.push(this.prepareIncome(fromModel.INCOMETYPE.PA));
  //   // incomes.push(this.prepareIncome(fromModel.INCOMETYPE.AN));
  //   // incomes.push(this.prepareIncome(fromModel.INCOMETYPE.OT));
  //   plan.incomes = incomes; 
  // }

  // prepareIncome(incomeType: fromModel.INCOMETYPE, client: fromModel.PlanClient){
  //   let income: fromModel.Income = { 
  //     "incId": Utils.newGuidByType(fromModel.GUIDTYPE.RCMINC),
  //     "incSource": fromModel.INCOMESOURCE.Ordinary,
  //     "incType": incomeType,
  //     "incDesc": "Employment Income",
  //     "owner": client.clientid,
  //     "growthType": fromModel.GROWTHTYPE.INF,
  //     //"growthRate": 2.5,
  //     "amtPeriod": [
  //       {
  //         "startType": fromModel.AMOUNTPERIODTYPE.Year,
  //         "startYr": new Date().getFullYear(), // current year
  //         // "startAge": client.age,
  //         "amount": client.salary,
  //         "endType": fromModel.AMOUNTPERIODTYPE.AtRet,
  //         // "endYr": 0,
  //         // "endAge": 0
  //       }
  //     ],
  //     "isIncluded": true
  //   };    
  //   return income;
  // }
  

}
